export default __webpack_public_path__ + "static/media/green_check.9c94c3aa.svg";